import { render, staticRenderFns } from "./NotificationCategory.vue?vue&type=template&id=8126f212&"
import script from "./NotificationCategory.vue?vue&type=script&lang=js&"
export * from "./NotificationCategory.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports